import YGrid from './YGrid'

export default YGrid



// WEBPACK FOOTER //
// ./src/legacy/containers/Graphs/components/YGrid/index.js